module.exports = __webpack_public_path__ + "Roboto-Thin.1f35e6a11d27d2e10d28.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/roboto/Roboto-Thin.woff2
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Thin.woff2
// module chunks = styles